.root {
	@apply --mx-bg(var(--m-gray-wash));
	display: flex;
	flex-direction: column;
	gap: var(--m-sp-sm);
	border-radius: var(--m-rd-md);
	padding: var(--m-sp-md);
}

.actions {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	gap: var(--m-sp-sm);
}
